// src/Components/Modules/Inventory/StockTransfers.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import { Box, Typography, Paper, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions, Chip, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FaPlus, FaCheck } from 'react-icons/fa';
import Swal from 'sweetalert2';

export default function StockTransfers() {
    const [transfers, setTransfers] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ source_warehouse_id: '', dest_warehouse_id: '', transfer_date: new Date().toISOString().split('T')[0], notes: '', items: [{ item_id: '', item_name: '', quantity: 1 }] });

    const fetchData = async () => {
        const [tRes, wRes] = await Promise.all([AxiosAuthInstance.get('stock-transfers'), AxiosAuthInstance.get('warehouses')]);
        setTransfers(tRes.data.transfers || []);
        setWarehouses(wRes.data.warehouses || []);
    };
    useEffect(() => { fetchData(); }, []);

    const handleSave = async () => {
        try {
            await AxiosAuthInstance.post('stock-transfers', form);
            Swal.fire({ icon: 'success', title: 'Transfer Initiated!', timer: 1500, showConfirmButton: false });
            setDialogOpen(false);
            fetchData();
        } catch (err) { Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed' }); }
    };

    const handleComplete = async (id) => {
        if (await Swal.fire({ title: 'Complete Transfer?', icon: 'question', showCancelButton: true }).then(r => r.isConfirmed)) {
            await AxiosAuthInstance.post(`stock-transfers/${id}/complete`);
            fetchData();
        }
    };

    const statusColor = { pending: 'warning', in_transit: 'info', completed: 'success', cancelled: 'error' };

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Stock Transfers" />
            <Paper sx={{ p: 3, mb: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h5" fontWeight={700}>Warehouse Stock Transfers</Typography>
                <Button variant="contained" startIcon={<FaPlus />} onClick={() => setDialogOpen(true)}>New Transfer</Button>
            </Paper>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead><TableRow sx={{ bgcolor: '#f8f9fa' }}><TableCell>Source</TableCell><TableCell>Destination</TableCell><TableCell>Date</TableCell><TableCell>Status</TableCell><TableCell align="center">Action</TableCell></TableRow></TableHead>
                    <TableBody>
                        {transfers.map(t => (
                            <TableRow key={t.id} hover>
                                <TableCell>{t.source_warehouse?.warehouse_name}</TableCell>
                                <TableCell>{t.dest_warehouse?.warehouse_name}</TableCell>
                                <TableCell>{t.transfer_date}</TableCell>
                                <TableCell><Chip label={t.status} size="small" color={statusColor[t.status]} /></TableCell>
                                <TableCell align="center">
                                    {t.status === 'pending' && <Button size="small" variant="outlined" startIcon={<FaCheck />} onClick={() => handleComplete(t.id)}>Complete</Button>}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>New Stock Transfer</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <FormControl fullWidth size="small"><InputLabel>Source Warehouse</InputLabel><Select value={form.source_warehouse_id} label="Source Warehouse" onChange={e => setForm({...form, source_warehouse_id: e.target.value})}>{warehouses.map(w => <MenuItem key={w.id} value={w.id}>{w.warehouse_name}</MenuItem>)}</Select></FormControl>
                        <FormControl fullWidth size="small"><InputLabel>Destination Warehouse</InputLabel><Select value={form.dest_warehouse_id} label="Destination Warehouse" onChange={e => setForm({...form, dest_warehouse_id: e.target.value})}>{warehouses.map(w => <MenuItem key={w.id} value={w.id}>{w.warehouse_name}</MenuItem>)}</Select></FormControl>
                        <TextField label="Date" type="date" size="small" value={form.transfer_date} onChange={e => setForm({...form, transfer_date: e.target.value})} InputLabelProps={{shrink: true}} />
                        <TextField label="Notes" multiline rows={2} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} />
                    </Box>
                </DialogContent>
                <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={handleSave}>Create Transfer</Button></DialogActions>
            </Dialog>
        </Box>
    );
}